import { createReducer } from 'typesafe-actions'
import { setBackgroundImageTypeState } from '../actions/app/backgroundImageSwitcher.actions'

export const defaultState = 'DEFAULT'

const backgroundImageTypeReducer = createReducer(defaultState)
    .handleAction(setBackgroundImageTypeState, (state, action) => action.payload)

export default backgroundImageTypeReducer
